import { api } from './api';

export type EnvLinkStatus = 'ok' | 'no-game-task' | 'no-recipe' | 'incomplete';

export interface EnvLinkRow {
  jurisdiction: string;
  resolvedMarket: string | null;
  status: EnvLinkStatus;
  gameTaskKey: string | null;
  market: string | null;
  gameId: string | null;
  gameName: string | null;
  playUrl: string | null;
  generatedUrl: string | null;
  guideMd: string | null;
  warnings: string[];
}

export interface EnvLinkBundleMeta {
  fetchedAt: string;
  stale: boolean;
  staleReason?: string;
  jiraHost?: string;
}

export interface EnvLinkBundle {
  studio: string;
  studioSlug: string;
  gameName: string | null;
  orderKey: string | null;
  texecKey: string;
  recipeStatus: 'ok' | 'missing' | 'invalid';
  recipeError: string | null;
  jurisdictions: EnvLinkRow[];
  meta?: EnvLinkBundleMeta;
}

/**
 * Phase 2 env-links read API. The server lazily fetches Jira when called,
 * caches the result, and falls back to the on-disk copy with `meta.stale`
 * if Jira is unreachable.
 */
export const envLinksApi = {
  load: (runId: string) => api.get<EnvLinkBundle>(`/api/runs/${runId}/env-links`),
  refresh: (runId: string) => api.post<EnvLinkBundle>(`/api/runs/${runId}/env-links/refresh`),
};
